export const SETTINGS_ROUTES = [
  'settings-space',
  'settings-accounts',
  'settings-income',
  'settings-expense',
  'settings-contractors',
  'settings-access',
  'settings-calendar',
  'invest-profile',
  'banks-integrations',
  'trash',
  'settings-tags',
  'create-accounting',
];

export const PROFILE_ROUTES = [
  'profile-settings',
  'personalization',
  'notifications',
  'theming',
  'sessions',
  'user-api',
  'account-deletion',
];

export const HELP_ROUTES = [
  'ticket-system',
  'ticket-chat',
  'faq',
];

export const ACCOUNT_ROUTES = [
  ...SETTINGS_ROUTES,
  ...PROFILE_ROUTES,
  ...HELP_ROUTES,
];
